import React, { useEffect, useRef, useState } from "react";
import html2canvas from "html2canvas";
import "bootstrap/dist/css/bootstrap.min.css";
import JsBarcode from "jsbarcode";

function TagCreate() {
  const tagRef = useRef();
  const barcodeRef = useRef();

  const [form, setForm] = useState({
    product: "",
    packed: "",
    size: "",
    // waist: "81 cm",
    // inseam: "71 cm",
    qty: "",
    color: "",
    fabric: "",
    mrp: "",
    barcode: "",
    // marketedBy: "JAISTA SOLUTION PRIVATE LIMITED",
  });

  function calculateEAN13CheckDigit(number12) {
    let sum = 0;
    for (let i = 0; i < 12; i++) {
      let digit = parseInt(number12[i]);
      sum += i % 2 === 0 ? digit : digit * 3;
    }
    let checkDigit = (10 - (sum % 10)) % 10;
    return checkDigit;
  }

  const handleDownload = () => {
    const base = form.barcode.slice(0, 12);
    const checkDigit = calculateEAN13CheckDigit(base);
    const validBarcode = base + checkDigit;

    JsBarcode(barcodeRef.current, validBarcode, {
      format: "ean13",
      lineColor: "#000",
      width: 0.8,
      height: 35,
      displayValue: true,
      fontSize: 14,
      margin: 0,
    });
    html2canvas(tagRef.current, { scale: 4 }).then((canvas) => {
      const link = document.createElement("a");
      link.download = "tag.png";
      link.href = canvas.toDataURL();
      link.click();
    });
  };

  return (
    <div className="container py-4 tag-body">
      <h3 className="mb-3">Tag Generator (1 in × 1.5 in)</h3>

      {/* FORM */}
      <div className="row">
        <div className="col-md-4">
          {Object.keys(form).map((key) => (
            <div className="mb-2" key={key}>
              <label className="form-label text-capitalize">{key}</label>
              <input
                type="text"
                className="form-control form-control-sm"
                value={form[key]}
                onChange={(e) => setForm({ ...form, [key]: e.target.value })}
              />
            </div>
          ))}

          <button className="btn btn-primary mt-3" onClick={handleDownload}>
            Download Tag
          </button>
        </div>

        {/* TAG PREVIEW */}
        <div className="col-md-8 d-flex justify-content-center">
          <div
            ref={tagRef}
            className="tag-preview"
            style={{
              width: "100px", // 1 inch
              height: "192px", // 1.5 inch
              border: "1px solid #000",
              fontSize: "8px",
              lineHeight: "10px",
              background: "white",
            }}
          >
            <div
              style={{
                textAlign: "center",

                width: 0.8,
                height: 35,
              }}
            >
              <svg ref={barcodeRef}></svg>
            </div>

            <div style={{ marginTop: "20px" }}>Product: {form.product}</div>
            <div>Packed MM/YY: {form.packed}</div>
            {/* <div>Style: {form.style}</div> */}
            <div>Size: {form.size}</div>
            {/* <div>Inseam: {form.inseam}</div> */}
            <div>Net Quantity: {form.qty}</div>
            <div>Colour: {form.color}</div>
            <div>Fabric: {form.fabric}</div>

            <div
              style={{
                marginTop: "4px",
                fontWeight: "bold",
                textAlign: "center",
              }}
            >
              MAXIMUM RETAIL PRICE
              <br />
              Rs.{form.mrp}
              <br />
              (Inclusive of all taxes)
            </div>

            {/* <div style={{ fontSize: "7px", marginTop: "4px" }}>
              Marketed By: <br />
              {form.marketedBy}
            </div> */}
          </div>
        </div>
      </div>
    </div>
  );
}

export default TagCreate;
